import classNames from 'classnames';

import { BarChart3, Bell, Calendar, Database, LayoutPanelTop, Puzzle, Rss, Users } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import useUnreadNotifications from 'modules/notifications/ui/hooks/use-unread-notifications';
import UsersAppIcon from 'modules/ud-ui/components/icon/users-icon';
import React from 'react';
import useIsDev from 'shared/hooks/use-is-dev';
import useIsTest from 'shared/hooks/use-is-test';
import MenuItem from '../menu-item';

type Props = { className?: string };

const UDMenuSystemNavigation = React.memo((props: Props) => {
  const { unreadCount } = useUnreadNotifications();
  const isDev = useIsDev();
  const isTest = useIsTest();

  let badge = unreadCount > 0 ? { label: unreadCount.toString() } : undefined;

  return (
    <div className={classNames('flex flex-col', props.className)}>
      <MenuItem to={Pages.NOTIFICATIONS.INDEX} icon={<Bell size={16} />} label={'Уведомления'} badge={badge} />
      <MenuItem to={Pages.SCHEDULE.INDEX} icon={<Calendar size={16} />} label={'Расписание'} />
      <MenuItem to={Pages.ORGANIZERS.INDEX} icon={<Users size={16} />} label={'Организаторы'} adminOnly={true} />
      <MenuItem to={Pages.ROLES_MANAGER.INDEX} icon={<UsersAppIcon width={16} height={16} />} label={'Пользователи'} />
      <MenuItem to={Pages.TEMPLATE.INDEX} icon={<LayoutPanelTop size={16} />} label={'Шаблоны'} />
      <MenuItem to={Pages.MIGRATION.INDEX} icon={<Database size={16} />} label={'Миграция'} adminOnly={true} />
      <MenuItem to={Pages.ANALYTICS.INDEX} icon={<BarChart3 size={16} />} feature={'TOURNAMENT_ANALYTICS'} label={'Аналитика'} />
      <MenuItem
        to={Pages.MEDIA_MANAGER.INDEX}
        icon={<Rss size={16} />}
        feature={'MEDIA_MANAGER'}
        label={'Медиа менеджер'}
        hide={!isTest && !isDev}
      />
      <MenuItem to={Pages.TESTS.COMPONENTS} icon={<Puzzle size={16} />} label={'Компоненты'} adminOnly={true} hide={!isDev} />
    </div>
  );
});

export default UDMenuSystemNavigation;
